import { Card, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import StoresDownloadBadge from "../StoresDownloadBadge";
import type { PurchaseSuccessStoreNote } from "./types";

export const StoreNoteCard = ({
	note,
	ios,
	android,
}: PurchaseSuccessStoreNote) => {
	const theme = useAppTheme();

	return (
		<FlatCard>
			<Card.Content style={{ padding: 16 }}>
				<Box gap={16} alignItems="center">
					<Text
						variant="bodySmall"
						style={{
							textAlign: "center",
							color: theme.colors.onSurfaceVariant,
						}}
					>
						{note}
					</Text>
					<StoresDownloadBadge ios={ios} android={android} />
				</Box>
			</Card.Content>
		</FlatCard>
	);
};
